import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { AxiosAPI } from '../../../../../../../../helpers/AxiosAPI';
import { postAPI_Update_Property } from '../../../../../../../../constants/APIs';
import { PropertyForm } from './PropertyForm';
import GptTemplate from './GptTemplates';
import Validation from '../../../../../../../../components/Validation';
import { putAPI_Update_Domains, putAPI_Update_Subscribed_Property_Products } from '../../../../../../../../constants/APIs';
import { NotificationManager } from '../../../../../../../../components/common/react-notifications';
export default function UpdatePropertyForm({ id, groupId, gptTemplate, fetchProperties, groupCurrency }) {
  const [isUpdating, setIsUpdating] = useState(false);
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [isGptTemplate, setIsGptTemplate] = useState(false);
  const [msg, setMsg] = useState([]);
  const handleSubmit = async (data, applicableProducts) => {
    const formmatedData = { ...data, updater: 'admin' };
    const domainData = { domains: [...data.domains], updater: 'admin' };
    const UpdatedData = { ...applicableProducts, createdBy: 'admin' };
    // console.log(152, formmatedData, data);
    try {
      // First update domains
      const domainRes = await AxiosAPI({
        method: 'put',
        url: `${putAPI_Update_Domains}/${id}`,
        data: domainData,
      });

      if (
        domainRes.data?.HttpStatusCode === 400 &&
        domainRes.data?.Messages?.length > 0
      ) {
        setMsg(domainRes.data.Messages);
        setOpen(true);
        return;
      } else {
        AxiosAPI({
          method: 'put',
          url: `${putAPI_Update_Subscribed_Property_Products}/${id}`,
          data: UpdatedData,
        })
          .then(
            (res_2) => {
              NotificationManager.success(
                '',
                'Domain updated successfully',
                3000,
                null,
                null,
                'success'
              );
            }
          );
      }
      const propertyRes = await AxiosAPI({
        method: 'put',
        url: `${postAPI_Update_Property}/${id}`,
        data: formmatedData,
      });

      if (
        propertyRes.data?.HttpStatusCode === 400 &&
        propertyRes.data?.Messages?.length > 0
      ) {
        setMsg(propertyRes.data.Messages);
        setOpen(true);
      } else {
        setVisible(false);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    } catch (error) {
      console.error('Error during update:', error);
      NotificationManager.error(
        'An error occurred while updating.',
        'Error',
        3000
      );
    }
  };

  return (
    <div>
      <Button
        color="primary"
        size="sm"
        onClick={() => setIsUpdating(!isUpdating)}
      >
        Edit
      </Button>
      <Button
        className="ml-3"
        color="dark"
        size="sm"
        onClick={() => setIsGptTemplate(true)}
      >
        GPT Template
      </Button>
      {isUpdating && (
        <PropertyForm
          formLabel="Update Property"
          visible={isUpdating}
          toggle={() => {
            setIsUpdating(!isUpdating);
          }}
          id={id}
          submit={handleSubmit}
          groupId={groupId}
          groupCurrency={groupCurrency}
        />
      )}
      {isGptTemplate &&
        <GptTemplate
          id={id}
          visible={isGptTemplate}
          toggle={() => setIsGptTemplate(false)}
          gptTemplate={gptTemplate}
          fetchProperties={fetchProperties}>
        </GptTemplate>
      }
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </div>
  );
}
